import classNames from 'classnames';
import { FC, useCallback, useMemo } from 'react';
import { CrumbsType, ICrumb, ICrumbProps } from '../../types/crumb';
import { localeStore } from 'src/mobx/localesStore';
import './style.scss';

type TProps = Pick<
  ICrumbProps,
  'type' | 'activeCrumb' | 'onClick' | 'translateLabel' | 'roundedCounterValue' | 'withPartition' | 'crumbClassName' | 'counterClassName'
>;
interface IProps extends TProps {
  crumb: ICrumb;
}

const Crumb: FC<IProps> = ({ crumb, ...props }: IProps): JSX.Element => {
  const selectCrumb = useCallback(() => {
    props.onClick(crumb.value);
  }, [crumb]);

  const isCrumbType = useMemo((): boolean => props.type === CrumbsType.CRUMB, [props.type]);

  const counterValue = useMemo((): string | null => {
    if (!crumb.counter) return null;
    if (crumb.counter > 9 && props.roundedCounterValue) return '9+';
    return String(crumb.counter);
  }, [crumb, props.roundedCounterValue]);

  const crumbClassName = useMemo((): string => {
    const mainClassName: string = isCrumbType ? 'crumbs__crumb' : 'crumbs__tab';
    const activeClassName: string = isCrumbType ? ' crumbs__crumb_active' : ' crumbs__tab_active';

    return classNames(mainClassName, props.crumbClassName, {
      [activeClassName]: props.activeCrumb === crumb.value,
      'crumbs__tab_with-counter': crumb.counter && !isCrumbType,
      'input-error': crumb.error,
      'crumbs_with-partition': props.withPartition,
    });
  }, [crumb, isCrumbType, props.withPartition, props.crumbClassName, props.activeCrumb]);

  return (
    <li key={crumb.value} className={crumbClassName} onClick={selectCrumb}>
      {counterValue ? <span className={classNames('crumbs__tab-counter', props.counterClassName)}>{counterValue}</span> : null}
      <p className={isCrumbType ? 'crumbs__crumb-text' : 'crumbs__tab-text'}>{props.translateLabel ? localeStore.t(crumb.label) : crumb.label}</p>
    </li>
  );
};

export default Crumb;
